/**
 * 进入 /game 前统一准备 loading 页素材（封面 + 动画），详情页与 history 直达共用同一规则，
 * 保证不同入口进入游戏时 loading 页表现一致。
 */
import { selectCoverUrl } from './selectCoverUrl'

const COVER_KEY = 'gameCoverUrl'
const ANIMATION_KEY = 'gameLoadingAnimationUrl'

/** loading 封面：loadingCoverUrls 按用户哈希定一张（9:16），缺省回退详情 coverUrl */
export function resolveLoadingCoverUrl(book: any, memberId: string): string {
  const urls: string[] | undefined = book?.loadingCoverUrls
  if (urls && urls.length > 0 && memberId)
    return selectCoverUrl(memberId, urls) || book?.coverUrl || ''
  return book?.coverUrl || ''
}

/**
 * 写入 /game 页读取的 sessionStorage：封面有值才覆盖；
 * 动画 URL 较长不进 query，无值时清掉，避免上一本书的动画残留
 */
export function storeGameLoadingAssets(coverUrl: string, loadingAnimationUrl: string) {
  if (coverUrl)
    sessionStorage.setItem(COVER_KEY, coverUrl)
  if (loadingAnimationUrl)
    sessionStorage.setItem(ANIMATION_KEY, loadingAnimationUrl)
  else
    sessionStorage.removeItem(ANIMATION_KEY)
}
